import { ARRAY_ERROR } from 'final-form';

import { createTypedUseFormError } from 'hooks/useTypedFormField';
import { IKnmErknmForm } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmForm';

const useError = createTypedUseFormError<IKnmErknmForm>();

export const ErknmEventsError = () => {
  const errorInfo = useError('eventsErknm');
  const errorText = typeof errorInfo?.error === 'string' ? errorInfo.error : errorInfo?.error?.[ARRAY_ERROR] ?? '';
  const shouldShowError = typeof errorInfo?.error === 'string' || errorInfo?.touched;

  if (!shouldShowError) return null;

  return <p className="shared-input-error shared-row__small-margin">{errorText}</p>;
};
